import { environment } from "src/environments/environment"
import { PortingData } from "./PortingData.interface"

export const INITIAL_PORTING_DATA: PortingData = (environment.mock && environment.mockPortingData) ?  {
  porting: true,
  numbersCount: 2,
  numbers: ["12345", "67890", "", "", "", "", "", "", "", ""],
  provider: "Telekom Deutschland GmbH",
  owner: "other",
  title: "Herr",
  firstName: "Luke",
  lastName: "Skywalker",
  streetName: "Ittersdorfer Str",
  streetNumber: "36",
  postalCode: "66802",
  city: "Überherrn"
} : {
  porting: false,
  numbersCount: 1,
  numbers: ["", "", "", "", "", "", "", "", "", ""],
  provider: "",
  owner: "customer",
  title: "",
  firstName: "",
  lastName: "",
  streetName: "",
  streetNumber: "",
  postalCode: "",
  city: ""
}
